module.exports = __webpack_public_path__ + "static/media/paso9-cambio.06b9cf0a.png";